import { useEffect, useState } from "react";
import styles from "./PaymentPage.module.css";
import { Logo } from "../../constants";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight, DashboardIcon, IconSuccess } from "../../constants/svg";

const CONFIG = {
  success: {
    icon: <IconSuccess />,
    iconClass: "iconSuccess",
    headline: "Payment Successful 🎉",
    subtext:
      "Thank you for your payment. Your Awasource feature has been unlocked successfully.",
    pillLabel: "Successful",
    pillClass: "pillSuccess",
    dotClass: "dotSuccess",
  },
};

function Actions() {
  return (
    <>
      <h3 className={styles.nextTitle}>What happens next?</h3>
      <p className={styles.nextBody}>
        You can now access your unlocked insights and continue improving your
        career profile.
      </p>
      <div className={styles.btnRow}>
        <Link
          to="/ai-insights"
          className={`${styles.btn} ${styles.btnPrimary}`}
        >
          View My Insights <ArrowRight />
        </Link>
        <Link
          to="/ai-insights"
          className={`${styles.btn} ${styles.btnGhost}`}
        >
          <DashboardIcon /> Go to Dashboard
        </Link>
      </div>
    </>
  );
}

export default function PaymentPage() {
  const [state, setState] = useState("success");
  const [reference, setReference] = useState(null);
  const [param] = useSearchParams();
  const cfg = CONFIG["success"];

  useEffect(() => {
    if (param.get("reference")) {
      setReference(param.get("reference"));
    }
  }, [param]);

  const summaryRows = [
    { label: "Feature", value: "What to Improve", className: "" },
    { label: "Amount Paid", value: "₦5,000", className: "bold" },
    ...(reference
      ? [{ label: "Reference", value: reference, className: "mono" }]
      : []),
  ];

  return (
    <div className={styles.page}>
      <div className={styles.wrap}>
        {/* Brand */}
        <div className={styles.brand}>
          <Logo color="#030659" />
        </div>

        {/* Card */}
        <section className={styles.card}>
          {/* Icon + headline */}
          <div className={styles.hero}>
            <div className={`${styles.iconWrap} ${styles[cfg.iconClass]}`}>
              {cfg.icon}
            </div>
            <h1 className={styles.headline}>{cfg.headline}</h1>
            <p className={styles.subtext}>{cfg.subtext}</p>
          </div>

          {/* Payment summary */}
          <div className={styles.summary}>
            <div className={styles.summaryHead}>
              <span className={styles.summaryLabel}>Payment summary</span>
              <span className={`${styles.pill} ${styles[cfg.pillClass]}`}>
                <i className={`${styles.dot} ${styles[cfg.dotClass]}`} />
                {cfg.pillLabel}
              </span>
            </div>

            <div className={styles.rows}>
              {summaryRows.map(({ label, value, className }) => (
                <div key={label} className={styles.row}>
                  <span className={styles.rowLabel}>{label}</span>
                  <span
                    className={`${styles.rowValue} ${className === "bold" ? styles.rowBold : className === "mono" ? styles.rowMono : ""}`}
                  >
                    {value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className={styles.actions}>
            <Actions state={state} />
          </div>
        </section>

        {/* Footer note */}
        <p className={styles.footNote}>
          Need help? Email{" "}
          <a href="mailto:support@awasource.com" className={styles.footEmail}>
            support@awasource.com
          </a>{" "}
          with your reference.
        </p>
      </div>
    </div>
  );
}
